<template>
  <div
    class="relative flex flex-col items-center group w-fit"
    :class="[extraClass]"
    @mouseover="showTooltip"
    @mouseleave="hideTooltip"
  >
    <slot />
    <div
      v-if="isTooltipVisible && isTooltip"
      :class="['absolute transition-all duration-100 z-10 min-w-80', positionClass, maxWidth]"
    >
      <span
        :class="['relative rounded-lg z-10 px-3 py-2 text-xs text-wrap', bgColorClass, textColorClass,shadowClass]"
      >
        {{ tooltipText }}
      </span>
      <div :class="['absolute w-2.5 h-2.5 shadow-lg z-10', bgColorClass, arrowClass]" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    tooltipText: {
      type: String,
      required: true
    },
    alwaysVisible: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'top',
    },
    type: {
      type: String,
      default: 'black',
    },
    maxWidth:{
      type:String,
      required:false
    },
    extraClass:{
      type:String,
      required:false
    },
    isTooltip:{
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isTooltipVisible: false,
      positionClass:'',
      arrowClass:'',
      bgColorClass:'',
      textColorClass:'',
      shadowClass:''
    };
  },
  created() {
      switch (this.position) {
        case 'top':
          this.positionClass = 'bottom-full mb-2 flex flex-col items-center';
          this.arrowClass = '-bottom-2 mb-1 rotate-45';
          this.shadowClass = 'shadow-xl'
          break;
        case 'bottom':
          this.positionClass = 'top-full mt-2 flex flex-col items-center';
          this.arrowClass = '-top-2 mt-1 rotate-45';
          this.shadowClass = 'shadow-[0_-11px_25px_-5px_rgba(0,0,0,0.1)]';
          break;
        case 'left':
          this.positionClass = 'right-full mr-2 flex items-center top-1/2 transform -translate-y-1/2';
          this.arrowClass = '-right-2 mr-1 rotate-45';
          this.shadowClass = 'shadow-[20px_11px_19px_-8px_rgba(0,0,0,0.1)]';

          break;
        case 'right':
          this.positionClass = 'left-full ml-2 flex items-center top-1/2 transform -translate-y-1/2';
          this.arrowClass = '-left-2 ml-1 rotate-45';
          this.shadowClass = 'shadow-[-20px_11px_19px_-8px_rgba(0,0,0,0.1)]';
          break;
      }
      switch (this.type) {
        case 'black':
          this.bgColorClass = 'bg-black';
          this.textColorClass = 'text-white font-semibold';
          break;
        case 'white':
          this.bgColorClass = 'bg-white';
          this.textColorClass = 'text-black font-medium';
          break;
      }
  },
  methods: {
    showTooltip() {
      if (!this.alwaysVisible) {
        this.isTooltipVisible = true;
      }
    },
    hideTooltip() {
      if (!this.alwaysVisible) {
        this.isTooltipVisible = false;
      }
    }
  }
};
</script>
